<template>
  <multiselect
    :style="{ width: ratings && ratings.length ? 'auto' : '105px' }"
    placeholder="Type to search"
    selectLabel
    :hideSelected="false"
    :close-on-select="false"
    v-model="ratings"
    :multiple="true"
    @close="updateRatings"
    @remove="updateRatings"
    :searchable="false"
    :showLabels="false"
    :limitText="(count) => `+${count} more`"
    :limit="2"
    :options="surveyRatings"
    :custom-label="ratingLabel"
    track-by="score"
  >
    <template slot="placeholder">
      <span class="text-secondary"> <i class="far fa-smile"></i> All ratings </span>
    </template>
    <template slot="option" slot-scope="props">
      <div>
        <span class="text-capitalize">{{ props.option.emoti }} {{ props.option.title }}</span>
      </div>
    </template>
  </multiselect>
</template>

<script>
import { getRating, surveyRatings } from '@/lib/rating'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AudienceRatingFilter',
  components: {
    Multiselect
  },
  props: {
    surveyFilter: {
      type: Object
    }
  },
  data: () => ({
    surveyRatings: surveyRatings,
    ratings: []
  }),
  methods: {
    updateRatings() {
      this.$emit('updateRatings', { ratings: this.ratings?.map((r) => r.score) || [] })
    },
    ratingLabel({ emoti, title }) {
      return `${emoti} ${title}`
    }
  },
  mounted() {
    if (this.surveyFilter) {
      this.ratings = this.surveyFilter.ratings.map((rating) => getRating(rating))
    }
  }
}
</script>

<style lang="scss">
.multiselect__tag span {
  text-transform: capitalize;
}
</style>
